import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ palette, shadow, breakpoints }) => ({
  container: {
    [breakpoints.up('lg')]: {
      display: 'flex',
      alignItems: 'center',
      gap: rem(8),
    },
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    gap: rem(12),
    borderRadius: rem(16),
    boxShadow: shadow.medium,
    backgroundColor: palette.common.white,
    padding: rem(16),
    minHeight: rem(100),
    [breakpoints.up('lg')]: {
      minHeight: 'unset',
      padding: rem(24),
    },
  },
  stepNumber: {
    display: 'flex',
    padding: rem(8),
    minWidth: rem(40),
    minHeight: rem(40),
    borderRadius: rem(8),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.supporting.blue[900],
  },
  chevron: {
    width: 'auto',
    color: palette.neutral[500],
  },
  slider: {
    margin: `0 ${rem(-12)} ${rem(-12)} ${rem(-12)}`,
    '& .slick-slide > div': {
      padding: `0 ${rem(12)} ${rem(12)} ${rem(12)}`,
    },
  },
  sliderDots: {
    display: 'flex !important',
    listStyle: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    gap: rem(2),
    padding: 0,
  },
  dot: {
    display: 'inline-block',
    width: `${rem(4)} !important`,
    height: `${rem(4)} !important`,
    opacity: 0.5,
    borderRadius: '100%',
    backgroundColor: palette.neutral[200],
  },
  activeDot: {
    opacity: 1,
    backgroundColor: palette.neutral.main,
  },
}));
